<template>
    <div>
        <div id="big">
            <div class="bigContainer">
                <div class="modal fade" id="updateRecord" tabindex="-1" role="dialog"
                    aria-labelledby="exampleModalLabel" aria-hidden="true">
                    <div class="modal-dialog" role="document">
                        <div class="modal-content">
                            <div class="modal-header">
                                <h5 class="modal-title bold" id="exampleModalLabel"><i
                                        class="fa-solid fa-pen-to-square"></i> Chỉnh sửa Thư viện</h5>
                                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true" class="text-danger"><i
                                            class="fa-regular fa-circle-xmark"></i></span>
                                </button>
                            </div>
                            <div class="modal-body">
                                <form @submit.prevent="updateRecord()">
                                    <div class="form-group">
                                        <label class="bold">Tên Thư viện</label>
                                        <input v-model="record.library_name" type="text"
                                            class="form-control form-control-sm" id="exampleInputEmail1"
                                            aria-describedby="emailHelp" placeholder="Tên Document">
                                        <span v-if="errors.library_name" class="text-danger">{{ errors.library_name[0]
                                            }}<br></span>
                                    </div>
                                    <div class="row">
                                        <div class="col-6">
                                            <div class="big-container-image">
                                                <div class="inner-image-upload">
                                                    <label class="bold"><i class="fa-solid fa-wand-magic-sparkles"></i>
                                                        Ảnh bìa</label>
                                                    <div class="min-image-upload">
                                                        <input class="input-file" type="file" @change="previewImage"
                                                            accept="image/*" ref="fileInput" />
                                                        <span class="iconClound" v-if="previewImageSrc == null"><i
                                                                class="fa-solid fa-cloud-arrow-up"></i></span>
                                                        <div v-if="previewImageSrc" class="box-preview">
                                                            <img class="preview" :src="previewImageSrc" alt="Preview" />
                                                            <img src="@/assets/error.png" @click="removeFileImage"
                                                                class="close-img" alt="Remove">
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <span v-if="errors.library_image" class="text-danger">{{
                                                errors.library_image[0] }}<br></span>
                                        </div>
                                        <div class="col-6">
                                            <div class="row">
                                                <div class="col-12 form-group">
                                                    <label class="bold" for="exampleInputPassword1">Giá tiền
                                                        (VNĐ)</label>
                                                    <input v-model="record.library_price" type="text"
                                                        class="form-control" id="exampleInputPassword1"
                                                        placeholder="99.99">
                                                </div>
                                                <span v-if="errors.library_price" class="text-danger">{{
                                                    errors.library_price[0] }}<br></span>
                                            </div>
                                            <div class="row">
                                                <div class="col-12 form-group">
                                                    <label class="bold">Bộ môn của Thư viện</label>
                                                    <select class="form-control" v-model="record.id_category_library">
                                                        <option :value="category.id"
                                                            v-for="(category, index) in library_categories"
                                                            :key="index">{{ category.category_name }}</option>
                                                    </select>
                                                    <span v-if="errors.library_name" class="text-danger">{{
                                                        errors.library_name[0] }}<br></span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <br>
                                    <div class="form-group">
                                        <label class="bold" for="exampleInputEmail1">Mô tả Thư viện</label>
                                        <div>
                                            <RichTextEditor v-model="record.library_introduce" />
                                        </div>
                                        <span v-if="errors.library_introduce" class="text-danger">{{
                                            errors.library_introduce[0] }}<br></span>
                                    </div>
                                    <div class="col-6 p-0">
                                        <label class="bold" for="exampleInputEmail1">File tài liệu</label>
                                        <input class="mb-2" v-if="!nameFile" type="file" ref="fileInput" id="file"
                                            @change="handleFileUpload" accept=".rfa,.dwg" />
                                        <div v-if="nameFile" class="container-file-default">
                                            <img src="@/assets/video_file_default.png" alt="File Image"
                                                class="file-default-image" />
                                            <p class="name-file-upload">{{ nameFile }}</p>
                                            <img @click="removeFile" src="@/assets/error.png"
                                                class="close-img close-file" alt="Remove">
                                        </div>
                                        <div>
                                            <span v-if="errors.library_file" class="text-danger">{{
                                                errors.library_file[0]
                                            }}<br></span>
                                        </div>
                                    </div>
                                    <button type="submit" class="btn-pers" id="login_button"><i
                                            class="fa-solid fa-paper-plane"></i> Cập nhật</button>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import UserRequest from '@/restful/UserRequest';
import RichTextEditor from '@/components/common/RichTextEditor.vue'

export default {
    name: "UpdateRecord",
    setup() {

    },
    props: {
        library_categories: Array,
    },
    data() {
        return {
            selectedFile: null,
            previewImageSrc: null,
            linkImageSrc: null,
            updateImage: false,
            nameFile: null,
            linkFileBackup: null,
            updateFile: false,
            record: {
                id: null,
                library_introduce: null,
                library_name: null,
                library_file: null,
                library_price: null,
                library_image: null,
                id_category_library: null,
            },
            errors: {
                id: null,
                library_introduce: null,
                library_name: null,
                library_file: null,
                library_price: null,
                library_image: null,
                id_category_library: null,
            }
        }
    },
    mounted() {
        this.$onEvent('eventSelectedRecord', (recordSelected) => {
            this.record = { ...recordSelected };
            this.nameFile = this.$extractFileName(this.record.library_file);
            this.linkFileBackup = this.record.library_file;
            this.previewImageSrc = this.record.library_image;
            this.linkImageSrc = this.record.library_image;
        });
    },
    created() {
    },
    components: {
        RichTextEditor,
    },
    computed: {

    },
    methods: {
        previewImage(event) {
            const file = event.target.files[0];
            if (file) {
                const reader = new FileReader();
                reader.onload = (e) => {
                    this.previewImageSrc = e.target.result;
                    this.record.library_image = file;
                    this.updateImage = true;
                };
                reader.readAsDataURL(file);
            } else this.removeFileImage();
        },
        removeFileImage: function () {
            // this.record.course_image = this.previewImageSrc;
            this.previewImageSrc = null;
            // this.user.avatar = null;
            this.$refs.fileInput.value = '';
            this.updateImage = false;
        },
        handleFileUpload(event) {
            const file = event.target.files[0];
            if (file) {
                this.selectedFile = file;
                this.nameFile = this.selectedFile.name;
                this.record.library_file = file;
                this.updateFile = true;
            }
            else this.updateFile = false;
        },
        removeFile() {
            this.selectedFile = null;
            this.updateFile = false;
            this.nameFile = null;
        },
        updateRecord: async function () {
            try {
                const formData = new FormData();
                var fields = ['id', 'library_introduce', 'library_name', 'library_price', 'id_category_library'];
                for (let key in fields) formData.append(fields[key], this.record[fields[key]]);
                if (this.updateFile) {
                    formData.append('library_file', this.record.library_file);
                } else {
                    formData.append('library_file', this.linkFileBackup);
                }

                if (this.updateImage) {
                    formData.append('library_image', this.record.library_image);
                } else {
                    formData.append('library_image', this.linkImageSrc);
                }

                const { data, messages } = await UserRequest.post('admin/library/update', formData, true);
                this.$emitEvent('eventSuccess', messages[0]);
                for (let key in this.errors) this.errors[key] = null;
                var closePW = window.document.getElementById('updateRecord');
                closePW.click();
                this.record = data;
                this.$emitEvent('eventRegetDataRecords', '');
            }
            catch (error) {
                if (error.errors) this.errors = error.errors;
                else for (let key in this.errors) this.errors[key] = null;
                if (error.messages) this.$emitEvent('eventError', error.messages[0]);
            }

        },
    },
    watch: {

    },
}
</script>

<style scoped src="@/components/modal-responsive.css"></style>
<style scoped>
/* image upload */
.big-container-image {
    display: flex;
    align-items: center;
    align-content: center;
    /* height: 100%; */
}

.inner-image-upload {
    height: 50%;
    width: 100%;
}

.min-image-upload {
    background-color: #e9ecef;
    position: relative;
    text-align: center;
    /* width: 170px; */
    height: 170px;
    border-radius: 6px;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    transition: all 0.5s ease;
    width: 100%;
}

.min-image-upload .preview {
    /* width: 150px; */
    height: 150px;
    object-fit: cover;
    border-radius: 6px;
    cursor: default;
    width: 100%;
}

.min-image-upload:hover {
    transition: all 0.5s ease;
    background: #E8F5E9;
}

.input-file {
    opacity: 0;
    top: 0px;
    left: 0px;
    position: absolute;
    cursor: pointer;
    /* width: 150px; */
    height: 150px;
    width: 100%;
}

.box-preview {
    position: relative;
}

.iconClound {
    cursor: pointer;
    font-size: 60px;
    color: var(--user-color);
}

.close-img {
    position: absolute;
    top: -6px;
    right: -6px;
    width: 16px;
}

/* image upload */


/*  */
.modal-dialog {
    max-width: 800px;
}

/*  */


.modal.fade.show {
    padding-left: 0px;
}

.modal-content {
    /* margin-top: 100px; */
    border-radius: 10px;
}

.bigContainer .input-form {
    height: 40px;
    width: 100%;
    position: relative;
}

.bigContainer .input-form input {
    height: 100%;
    width: 100%;
    border: none;
    font-size: 17px;
    border-bottom: 2px solid silver;
    outline: none !important;
}

.input-form input:focus~label,
.input-form input:valid~label {
    transform: translateY(-20px);
    font-size: 15px;
    color: var(--user-color);
}

.input-form .underline.fix2:before {
    position: absolute;
    content: "";
    height: 100%;
    width: 100%;
    background: var(--user-color);
    transform: scaleX(0);
    transform-origin: center;
    transition: transform 0.3s ease;
}

.bigContainer .input-form label {
    position: absolute;
    bottom: 0px;
    left: 0;
    color: grey;
    pointer-events: none;
    transition: all 0.3s ease;
}

.input-form .underline {
    position: absolute;
    height: 2px;
    width: 100%;
    bottom: 0;
}

.input-form .underline:before {
    position: absolute;
    content: "";
    height: 100%;
    width: 100%;
    background: var(--user-color);
    transform: scaleX(0);
    transform-origin: center;
    transition: transform 0.3s ease;
}

.input-form input:focus~.underline:before,
.input-form input:valid~.underline:before {
    transform: scaleX(1);
}

@import url('https://fonts.googleapis.com/css2?family=Reem+Kufi+Ink');

#big {
    display: flex;
    position: relative;
}

.btn-pers {
    position: relative;
    left: 50%;
    padding: 1em 2.5em;
    font-size: 12px;
    text-transform: uppercase;
    letter-spacing: 2.5px;
    font-weight: 700;
    color: #000;
    background-color: #fff;
    border: none;
    border-radius: 45px;
    box-shadow: 0px 8px 15px rgba(0, 0, 0, 0.1);
    transition: all 0.3s ease 0s;
    cursor: pointer;
    outline: none;
    transform: translateX(-50%);
}

.btn-pers:hover {
    background-color: var(--user-color);
    box-shadow: var(--btn-hover);
    color: #fff;
    transform: translate(-50%, -7px);
}

.btn-pers:active {
    transform: translate(-50%, -1px);
}

#inputPassword {
    padding-right: 26px;
}
</style>
